<template>
  <div class="dataloggerManage">
    <div class="section">
      <div class="search">
        <div class="searchLeft">
          <div class="search-title">
            <span>{{ $t('datalogger.ascii_display') }}</span>
            <el-switch class="eb-switch" @change="getDataloggerLog()" v-model="search.ascllOpen" :active-value="1"
            :inactive-value="0">
            </el-switch>
          </div>
          <div class="tool">
            <div class="datePreNext">
              <span class="date-icon"></span>
              <!-- 上一天 -->
              <span class="date-btn date-pre" @click="toPreDay"></span>
              <!-- 日期选择器 -->
              <el-date-picker v-model="selectedDate" :editable="false" :clearable="false" popper-class="select-date"
                          :picker-options="pickerDayOptions" ref="dateDay"></el-date-picker>
              <!-- 下一天 -->
              <span class="date-btn date-next" @click="toNextDay"></span>
            </div>
          </div>
          <div style="display: flex;justify-content: flex-start;">
            <el-input class="searchAll" ref="iptFocus" v-model.trim="search.search"
                @keyup.enter.native="getDataloggerLog(true)" :placeholder="this.$t('datalogger.Ple_PN')" clearable>
                <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
              </el-input>
              <span class="search-device" @click="getDataloggerLog(true)">{{ $t('recharge.Search') }}</span>
          </div>
        </div>
      </div>
      <el-table :data="dataloggerLog" border stripe height="100%" :row-style="{ height: 0 }" :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" v-loading="loadingDatalogger"
        element-loading-spinner="el-icon-loading" class="tablemain tableloding">
        <el-table-column
        :label="this.$t('settingalarm.list')"
          fixed
          type="index"
          width="70">
        </el-table-column>
        <el-table-column width="280px;" :show-overflow-tooltip="true"
          :label="this.$t('alarm.Occurrence_time')">
          <template slot-scope="scope">
            <span>{{scope.row.gts ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="140px;"
          :label="this.$t('datalogger.datalogger_log')">
          <template slot-scope="scope" >
            <span style="display: block;text-align: left;">{{scope.row.log ||"--"}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <span class="" style="margin-left:16px;"></span>
        <el-pagination class="pagination" background @size-change="getDataloggerLog(true)"
          @current-change="() => getDataloggerLog()" :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import dataloggerDialog from "@/components/dialognew/dataloggernew";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { i18n } from '@/i18n';
export default {
  components: {
    dataloggerDialog,
  },
  data () {
    return {
      search: {
        search:"",
        ascllOpen:0
      },
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 50
      }, // 分页数据
      loadingDatalogger: false,
      dataloggerLog: [],
      // 搜索弹出
      showSearch: false,
      selectedDate: new Date(), // 所选时间
      pickerDayOptions: {
        shortcuts: [{
          text: i18n.t('device.cur_today') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1) + '/' +
            String(new Date().getDate())
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate(time) {
          const times = new Date(new Date().toLocaleDateString()).getTime() - 3 * 8.64e7 + 1 
          return time.getTime() > Date.now() || time.getTime() < times
          // return time.getTime() > Date.now(); // 设置选择今天以及今天之前的日期
        },
      },
    };
  },
  computed: {
  },
  watch: {
    selectedDate () {
      this.getDataloggerLog()
    }
  },
  created () {

  },
  methods: {
    // 切换上一天
    toPreDay () {
      let aimTime = this.$filter.formatDate(this.$refs.dateDay.value, "yyyy-MM-dd");
      let preDay = this.$tool.getYestoday(aimTime);
      // 日志只支持查询3天内
      if (new Date(preDay)<Date.now()-3*8.64e7) return this.$message.warning(this.$t("datalogger.noDate"));
      // this.selectedDate = preDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(preDay)) {
        const [y, m, d] = preDay.split('-');
        this.selectedDate = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.selectedDate = preDay;
      }

    },
    // 切换下一天
    toNextDay () {
      let dayValue= new Date(this.$refs.dateDay.value)
      if (dayValue>Date.now()-8.64e7) return this.$message.warning(this.$t("device.noDate"));
      let aimTime = this.$filter.formatDate(this.$refs.dateDay.value, "yyyy-MM-dd");
      let nextDay = this.$tool.getNextday(aimTime);
      // this.selectedDate = nextDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(nextDay)) {
        const [y, m, d] = nextDay.split('-');
        this.selectedDate = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.selectedDate = nextDay;
      }
    },
    // 数采器日志数据
    getDataloggerLog(reset){
      this.loadingDatalogger=true
      if (reset) this.pagination.currentPage = 1;
      let date = this.$filter.formatDate(this.selectedDate, 'yyyyMMdd');
      let params={
        pn:this.search.search,
        ascllOpen:this.search.ascllOpen,
        page: this.pagination.currentPage-1,
        pageSize: this.pagination.pagesize,
        i18n: this.$lang.currentLang,
        yyyymmdd: String(date),
      }
      this.$request.get("adminQueryCollectorLogOneDayPaging",params).then(res=>{
        this.loadingDatalogger=false
        if (res.err==0) {
          this.dataloggerLog=res.dat.items
          this.pagination.total=res.dat.total
        }else{
          this.dataloggerLog = [];
          this.pagination.total = 0;
        }
      }).catch((err)=>{
        this.loadingDatalogger=false
        this.dataloggerLog = [];
        this.pagination.total = 0;
      })
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.dataloggerManage {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .ico-recharge {
    background: url(../../../../assets/img/general/Icon_Recharge.png);
  }

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background: rgb(34, 45, 53);
      .searchLeft{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .search-title{
           //开关按钮
           color: #fff;
           padding: 5px;
           display: flex;
           justify-content: center;
           align-items: center;
           .eb-switch {
             
             // 默认(false)
             &.el-switch {
             
               // Input
               // .el-switch__input {}
               // 轨道
               /deep/.el-switch__core {
                 position: relative;
                 vertical-align: middle;
                 margin: 0;
                 display: inline-block;
                 width: 40px;
                 height: 20px;
                 outline: 0;
                 border-radius: 10px;
                 box-sizing: border-box;
                 background-color: #666;
                 border: 1px solid #666;
                 cursor: pointer;
                 transition: border-color .3s, background-color .3s;
             
                 // transition: unset;
                 // 开关把手
                 &:after {
                   content: "";
                   width: 12px;
                   height: 12px;
                   top: 3px;
                   left: 3px;
                   box-sizing: border-box;
                   background-color: #fff;
                   border: 1px solid #fff;
                   border-radius: 100%;
                 }
               }
             }
             
             // 激活(true)
             &.el-switch.is-checked {
             
               // 轨道
               /deep/.el-switch__core {
                 background-color: @primaryTextColor;
                 border: 1px solid @primaryTextColor;
             
                 // 开关把手
                 &:after {
                   content: "";
                   left: 100%;
                   margin-left: -16px;
                   background-color: rgba(255, 255, 255, 1);
                   border: 1px solid rgba(255, 255, 255, 1);
                 }
               }
             }
           }
         }
        
        
        .tool {
          /deep/.el-date-editor.el-input .el-input__prefix {
            right: auto;
            left: 16px;
            font-size: 16px;
            color: #00FEBB;
          }

          /deep/.el-date-editor.el-input .el-input__inner {
            height: 46px;
            padding-left: 52px;
            background: transparent;
            color: #ffffff;
            border: none;
            border-radius: 0px;
            // border-left: 1px solid #7B8395;
            // border-right: 1px solid #7B8395;
          }

          /deep/.el-date-editor.el-input .el-input__suffix .el-input__icon:after {
            content: "";
            display: inline-block;
            position: absolute;
            top: 12px;
            right: -2px;
            height: 20px;
            width: 20px;
            background: url(../../../../assets/img/general/Icon_Down_Border.png) no-repeat;
            background-size: 100%;
            background-position: center;
          }

          // 时间图标
          /deep/.el-icon-date:before {
            content: "";
            display: inline-block;
            position: absolute;
            top: 12px;
            left: 0px;
            height: 24px;
            width: 24px;
            background: url(../../../../assets/img/general/Icon_Calendar.png) no-repeat;
            background-size: 100%;
            background-position: center;
          }

          // 日期盒子
          .datePreNext {
            padding: 0px 16px;
            border-right: 1px solid #7B8395;

            /deep/.datepicker {
              margin: 0px;
              // margin-right: 16px;
            }

            /deep/.el-date-editor {
              margin-right: 16px;
            }

            /deep/.el-date-editor.el-input {
              width: 150px;
            }

            /deep/.el-date-editor.el-input .el-input__inner {
              padding: 0px;
              text-align: center;
            }

            //.el-input__prefix,
            //.el-input__suffix
            /deep/.el-input__prefix {
              display: none;
            }

            /deep/.el-input__suffix {
              top: 2px;
              right: 16px;
            }

            .date-icon {
              display: inline-block;
              width: 24px;
              height: 24px;
              background: url(../../../../assets/img/general/Icon_Calendar.png);
              background-size: 100%;
              background-position: center;
              background-repeat: no-repeat;
              vertical-align: middle;
              margin-right: 16px;
            }

            .date-pre {
              background: url(../../../../assets/img/general/Chart_Date_Pre.png);
            }

            .date-next {
              background: url(../../../../assets/img/general/Chart_Date_Next.png);
            }

            .date-btn {
              color: #ffffff;
              cursor: pointer;
              display: inline-block;
              height: 16px;
              width: 16px;
              background-size: 100%;
              background-position: center;
              background-repeat: no-repeat;
              vertical-align: middle;
            }
          }
        }
        .searchAll {
        /deep/.el-input__inner {
          width: 220px;
          padding-left: 10px;
        }
        }

        .search-device {
        display: inline-block;
        line-height: 48px;
        padding: 0 15px;
        width: 100%;
        font-size: 14px;
        background: #202D35;
        color: #33FFB6;
        cursor: pointer;
        border-right:1px solid #7B8395 ;

        &:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }
        }

        .search-hide {
        display: inline-block;
        // position: absolute;
        // right: -58px;
        // line-height: 48px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 15px;
        font-size: 14px;
        background: #202D35;
        color: #7B8395;
        border-left: 1px solid #7B8395;
        cursor: pointer;

        &:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }
        }
      }
      

      .active {
        color: #00FEBB;
        border-bottom: 2px solid #00FEBB;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }
      .batch-alert {
        height: 48px;
        line-height: 48px;
      }
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
    
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      .operation1 i {
        color: @primaryColorTransparency30;
      }

      // 表格右侧边线
      // /deep/.el-table--border::after, 
      // /deep/.el-table--group::after {
      //   width: 0px;
      // }
      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>
<style lang="less">
// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    display: flex;
    align-items: center;
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

// #时间选择器 el-date-picker#
.select-date {

  // 下拉
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  // 切换日 -----
  // 头部切换
  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  // 前后切换
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  // 一周
  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  // 日
  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00FEBB;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }

  .el-date-table td.available:hover {
    color: #00FEBB;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  // 切换月 -----
  .el-date-picker__header--bordered {
    border: none;
  }
}
.tablemain.el-table--border::after {
  display: none;
}
</style>
<style lang="less">
// 日期选择器增加今日快捷
.select-date {
  width: 320px !important;
  padding-top: 10px;

  // 头部
  .el-date-picker__header {
    width: 100%;
    margin: 12px 0px !important;
    padding: 0px 30px !important;
  }

  .el-picker-panel__body-wrapper {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: flex-end;

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }
}
.el-date-table td.disabled div {
  background-color: #222D35 !important;
  color: #606266 !important;
}
</style>
